<template>
  <div class="wish-list-contents__header">
    <div class="wish-list-contents__title">
      <div class="wish-list-contents__title-suffix subhead-bold">
        ほしいものリスト
      </div>
    </div>
    <div class="wish-list-contents__edit-link body">
      <a :href="editLimitPath">個数設定</a>
      <a :href="editOrderPath">並べ替え</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nickname: {
      type: String,
      require: false,
      default: ''
    },
    editLimitPath: {
      type: String,
      require: false,
      default: ''
    },
    editOrderPath: {
      type: String,
      require: false,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__header {
    max-width: $small-contents-width;
    margin: 0 auto 24px;
    padding: 32px 16px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
  }

  &__title-nickname {
    @extend %subhead-bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__title-suffix {
    white-space: nowrap;
  }

  &__edit-link {
    flex-shrink: 0;
    padding-left: 16px;
    display: flex;
    gap: 16px;
  }
}
</style>
